import React, { useEffect, useState } from 'react'
import Robin from 'roundrobin'
import { Link, withRouter } from 'react-router-dom'
import CloseIcon from '@material-ui/icons/Close';
import { CircularProgress, Button } from '@material-ui/core'

function Fights(props) {
	const [matchs, setMatchs] = useState([]);
	const baseURL = process.env.PUBLIC_URL;
	const close = ()=>{
		props.history.replace(baseURL+'/dashboard')
	}

	/* Use Effect -------------------------------------------- */	

	useEffect (()=> {
		
		setMatchs(Robin(props.location.state.length, props.location.state));
		
	},[]);
	
		if(matchs.length != 0){
			console.log(matchs);
			return (
				<main>
					<header className="header-aux">
						<div></div>
						<h3>Porrada</h3>
						<CloseIcon onClick={close} />
					</header>
					<section className="container-plain">
						<div className="info"><span></span>Descansa</div>
							{ matchs.map((lucha, i) => { 
								return (
									<div>
										<div className="round"> Combate {i+1}</div>
										<div className="fightList">
											{lucha.map(combate => {
												return <div className={combate.includes('DESCANSA')? 'rest' : 'fight'}>
														{combate[0] === 'DESCANSA' ? null : <span>{combate[0]}</span>}
														{combate.includes('DESCANSA')? null : <span>VS</span>}
														{combate[1] === 'DESCANSA' ? null : <span>{combate[1]}</span>}
													</div>
											})}
										</div>
								    </div>
								)
							})
						}
					
					</section>
				</main>
			)
	} else {
		return (
			<div className="loading">
				<CircularProgress />
			</div>
			)
	}
}

export default withRouter(Fights)